module.exports = __webpack_public_path__ + "media/images/athletes/4332-61adef8b3310a22cf71a678c3fdf1c0f.png";